import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/quoteMargin`;

interface DeleteQuoteMarginConfigurationCommandArgs {
  sellerId: string;
}

export default async function deleteQuoteMarginConfigurationCommand({
  sellerId,
}: DeleteQuoteMarginConfigurationCommandArgs): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BaseBackResponse>(buildUrl(url), {
      method: SUPPORTED_METHODS.DELETE,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
